import { Footer } from '../components/footer';
import { Camp67Header } from '../components/camp67-header/camp67-header';
import { MetaFunction } from '@remix-run/cloudflare';
import { Link } from '@remix-run/react';

export const meta: MetaFunction = () => {
  return [
    { title: 'Help Center - camp67' },
    {
      name: 'description',
      content: "Get in touch with us. We're here to help!",
    },
    {
      tagName: 'link',
      name: 'canonical',
      href: 'https://camp67.com/support',
    },
  ];
};

export default function SupportPage() {
  return (
    <>
      <div className="bg-yellow-50">
        <div className="m-auto w-full rounded-b-md border-dotted border-b-black border-b pb-7">
          <Camp67Header isLogoLight={false} isDarkGlowHidden={true} textColor="dark" />
        </div>
        <main className="text-center py-20">
          <h1 className="text-2xl font-serif">Contact Us</h1>
          <p className="mt-8">
            <i>camp67 is offered by Sukrit Wellness Tours Private Limited.</i>
          </p>
          <p className="mt-2">
            Camp Address: Triveni Sangam Marg, Near Sangam Ghat,
            <br />
            Daraganj, Prayagraj, Uttar Pradesh 211006 (Landmark: Near Pontoon Bridge 2)
          </p>
          <p className="mt-8">
            <i>For any questions or concerns, please contact us at:</i>
          </p>
          <p className="mt-2">Email: support@camp67.com / bookings@camp67.com</p>
          <p>Phone/WhatsApp: +91 8485835675 / +91 8860092457</p>
          <br />
          <Link prefetch="intent" to="/terms-of-service" className="underline">
            See our Terms of Service &rarr;
          </Link>
        </main>
      </div>
      <Footer isHome={false} />
    </>
  );
}
